export default [
  {
    id: 'Agriculture_forestry_and_fishing',
    title: 'Agriculture, forestry and fishing',
    children: [
      {
        id: 'Agriculture',
        title: 'Agriculture',
      },
      {
        id: 'Aquaculture',
        title: 'Aquaculture',
      },
      {
        id: 'Forestr_and_Logging',
        title: 'Forestry and Logging',
      },
      {
        id: 'Fishing_Hunting_and_Trapping',
        title: 'Fishing, Hunting and Trapping',
      },
      {
        id: 'Agriculture_Forestry_and_Fishing_Support_Service',
        title: 'Agriculture, Forestry and Fishing Support Service',
      },
    ],
  },
  {
    id: 'Mining',
    title: 'Mining',
    children: [
      {
        id: 'Coal_Mining',
        title: 'Coal Mining',
      },
      {
        id: 'Oil_and_Gas_Extraction',
        title: 'Oil and Gas Extraction',
      },
      {
        id: 'Metal_Ore_Mining',
        title: 'Metal Ore Mining',
      },
      {
        id: 'Non-Metallic_Mineral_Mining_and_Quarrying09',
        title: 'Non-Metallic Mineral Mining and Quarrying09',
      },
      {
        id: 'Exploration_and_Other_Mining_Support_Services',
        title: 'Exploration and Other Mining Support Services',
      },
    ],
  },
  {
    id: 'Manufacturing',
    title: 'Manufacturing',
    children: [
      {
        id: 'Food_Product_Manufacturing',
        title: 'Food Product Manufacturing',
      },
      {
        id: 'Beverage_and_Tobacco_Product_Manufacturing',
        title: 'Beverage and Tobacco Product Manufacturing',
      },
      {
        id: 'Textile_Leather_Clothing_and_Footwear_Manufacturing',
        title: 'Textile, Leather, Clothing and Footwear Manufacturing',
      },
      {
        id: 'Wood_Product_Manufacturing',
        title: 'Wood Product Manufacturing',
      },
      {
        id: 'Pulp_Paper_and_Converted_Paper_Product_Manufacturing',
        title: 'Pulp, Paper and Converted Paper Product Manufacturing',
      },
      {
        id: 'Printing_including_the_Reproduction_of_Recorded_Media',
        title: 'Printing (including the Reproduction of Recorded Media)',
      },
      {
        id: 'Petroleum_and_Coal_Product_Manufacturing',
        title: 'Petroleum and Coal Product Manufacturing',
      },
      {
        id: 'Basic_Chemical_and_Chemical_Product_Manufacturing',
        title: 'Basic Chemical and Chemical Product Manufacturing',
      },
      {
        id: 'Polymer_Product_and_Rubber_Product_Manufacturing',
        title: 'Polymer Product and Rubber Product Manufacturing',
      },
      {
        id: 'Non-Metallic_Mineral_Product_Manufacturing',
        title: 'Non-Metallic Mineral Product Manufacturing',
      },
      {
        id: 'Primary_Metal_and_Metal_Product_Manufacturing',
        title: 'Primary Metal and Metal Product Manufacturing',
      },
      {
        id: 'Fabricated_Metal_Product_Manufacturing',
        title: 'Fabricated Metal Product Manufacturing',
      },
      {
        id: 'Transport_Equipment_Manufacturing',
        title: 'Transport Equipment Manufacturing',
      },
      {
        id: 'Machinery_and_Equipment_Manufacturing',
        title: 'Machinery and Equipment Manufacturing',
      },
      {
        id: 'Furniture_and_Other_Manufacturing',
        title: 'Furniture and Other Manufacturing',
      },
    ],
  },
  {
    id: 'Electricity_gas_water_and_waste_services',
    title: 'Electricity, gas, water and  waste services',
    children: [
      {
        id: 'Electricity_Supply',
        title: 'Electricity Supply',
      },
      {
        id: 'Gas_Supply',
        title: 'Gas Supply',
      },
      {
        id: 'Water Supply_Sewerage_and_Drainage_Services',
        title: 'Water Supply, Sewerage and Drainage Services',
      },
      {
        id: 'Waste_Collection_Treatment_and_Disposal_Services',
        title: 'Waste Collection, Treatment and Disposal Services',
      },
    ],
  },
  {
    id: 'Construction',
    title: 'Construction',
    children: [
      {
        id: 'Building_Construction',
        title: 'Building Construction',
      },
      {
        id: 'Heavy_and_Civil_Engineering_Construction',
        title: 'Heavy and Civil Engineering Construction',
      },
      {
        id: 'Construction_Services',
        title: 'Construction Services',
      },
    ],
  },
  {
    id: 'Wholesale_trade',
    title: 'Wholesale trade',
    children: [
      {
        id: 'Basic_Material_Wholesaling',
        title: 'Basic Material Wholesaling',
      },
      {
        id: 'Machinery_and_Equipment_Wholesaling',
        title: 'Machinery and Equipment Wholesaling',
      },
      {
        id: 'Motor_Vehicle_and_Motor_Vehicle_Parts_Wholesaling',
        title: 'Motor Vehicle and Motor Vehicle Parts Wholesaling',
      },
      {
        id: 'Grocery_Liquor_and_Tobacco_Product_Wholesaling',
        title: 'Grocery, Liquor and Tobacco Product Wholesaling',
      },
      {
        id: 'Other_Goods_Wholesaling',
        title: 'Other Goods Wholesaling',
      },
      {
        id: 'Commission-Based_Wholesaling',
        title: 'Commission-Based Wholesaling',
      },
    ],
  },

  {
    id: 'Retail_trade',
    title: 'Retail trade',
    children: [
      {
        id: 'Motor_Vehicle_and_Motor_Vehicle_Parts_Retailing',
        title: 'Motor Vehicle and Motor Vehicle Parts Retailing',
      },
      {
        id: 'Fuel_Retailing',
        title: 'Fuel Retailing',
      },
      {
        id: 'Food_Retailing',
        title: 'Food Retailing',
      },
      {
        id: 'Other_Store-Based_Retailing',
        title: 'Other Store-Based Retailing',
      },
      {
        id:
          'Non-Store_Retailing_and_Retail_Commission-Based_Buying_and/or_Selling',
        title:
          'Non-Store Retailing and Retail Commission-Based Buying and/or Selling',
      },
    ],
  },

  {
    id: 'Accommodation_and_food_services',
    title: 'Accommodation and food services',
    children: [
      {
        id: 'Accommodation',
        title: 'Accommodation',
      },
      {
        id: 'Food_and_Beverage_Services',
        title: 'Food and Beverage Services',
      },
    ],
  },

  {
    id: 'Transport_postal_and_warehousing',
    title: 'Transport, postal and warehousing',
    children: [
      {
        id: 'Road_Transport',
        title: 'Road Transport',
      },
      {
        id: 'Rail_Transport',
        title: 'Rail Transport',
      },
      {
        id: 'Water_Transport',
        title: 'Water Transport',
      },
      {
        id: 'Air_and_Space_Transport',
        title: 'Air and Space Transport',
      },
      {
        id: 'Other_Transport',
        title: 'Other Transport',
      },
      {
        id: 'Postal_and_Courier_Pick-up_and_Delivery_Services',
        title: 'Postal and Courier Pick-up and Delivery Services',
      },
      {
        id: 'Transport_Support_Services',
        title: 'Transport Support Services',
      },
      {
        id: 'Warehousing_and_Storage_Services',
        title: 'Warehousing and Storage Services',
      },
    ],
  },
  {
    id: 'Information_media_and _telecommunications',
    title: 'Information media and telecommunications',
    children: [
      {
        id: 'Publishing_except_Internet_and_Music_Publishing',
        title: 'Publishing (except Internet and Music Publishing)',
      },
      {
        id: 'Motion_Picture_and_Sound_Recording_Activities',
        title: 'Motion Picture and Sound Recording Activities',
      },
      {
        id: 'Broadcasting_except_Internet)',
        title: 'Broadcasting (except Internet)',
      },
      {
        id: 'Internet_Publishing_and_Broadcasting',
        title: 'Internet Publishing and Broadcasting',
      },
      {
        id: 'Telecommunications_Services',
        title: 'Telecommunications Services',
      },
      {
        id:
          'Internet_Service_Providers_Web_Search_Portals_and_Data_Processing_Services',
        title:
          'Internet Service Providers, Web Search Portals and Data Processing Services',
      },
      {
        id: 'Library_and_Other_Information_Services',
        title: 'Library and Other Information Services',
      },
    ],
  },
  {
    id: 'Financial_and_insurance_services',
    title: 'Financial and insurance services',
    children: [
      {
        id: 'Finance',
        title: 'Finance',
      },
      {
        id: 'Insurance_and_Superannuation_Funds',
        title: 'Insurance and Superannuation Funds',
      },
      {
        id: 'Auxiliary_Finance_and_Insurance_Services',
        title: 'Auxiliary Finance and Insurance Services',
      },
    ],
  },
  {
    id: 'Rental_hiring_and_real_estate_services',
    title: 'Rental, hiring and real estate services',
    children: [
      {
        id: 'Rental_and_Hiring_Services_except Real Estate',
        title: 'Rental and Hiring Services (except Real Estate)',
      },
      {
        id: 'Property_Operators_and_Real_Estate_Services',
        title: 'Property Operators and Real Estate Services',
      },
    ],
  },
  {
    id: 'Professional_scientific_and_technical_services',
    title: 'Professional, scientific and technical services',
    children: [
      {
        id:
          'Professional_Scientific_and_Technical_Services_(Except_Computer_System_Design_and_Related_Services)',
        title:
          'Professional, Scientific and Technical Services (Except Computer System Design and Related Services)',
      },
      {
        id: 'Computer_System_Design_and_Related_Services',
        title: 'Computer System Design and Related Services',
      },
    ],
  },

  {
    id: 'Administrative_and_support_services',
    title: 'Administrative and support services',
    children: [
      {
        id: 'Administrative_Services',
        title: 'Administrative Services',
      },
      {
        id: 'Building_Cleaning_Pest_Control_and_Other_Support_Services',
        title: 'Building Cleaning, Pest Control and Other Support Services',
      },
    ],
  },
  {
    id: 'Public_administration_and_safety',
    title: 'Public administration and safety',
    children: [
      {
        id: 'Public_Administration',
        title: 'Public Administration',
      },
      {
        id: 'Defence',
        title: 'Defence',
      },
      {
        id: 'Public_Order_Safety_and_Regulatory_Services',
        title: 'Public Order, Safety and Regulatory Services',
      },
    ],
  },
  {
    id: 'Education_and_training',
    title: 'Education and training',
    children: [
      {
        id: 'Preschool_and_School_Education',
        title: 'Preschool and School Education',
      },
      {
        id: 'Tertiary_Education',
        title: 'Tertiary Education',
      },
      {
        id: 'Adult_Community_and_Other_Education',
        title: 'Adult, Community and Other Education',
      },
    ],
  },
  {
    id: 'Health_care_and_social_assistance',
    title: 'Health care and social assistance',
    children: [
      {
        id: 'Hospitals',
        title: 'Hospitals',
      },
      {
        id: 'Medical_and_Other_Health_Care_Services',
        title: 'Medical and Other Health Care Services',
      },
      {
        id: 'Residential_Care_Services',
        title: 'Residential Care Services',
      },
      {
        id: 'Social_Assistance_Services',
        title: 'Social Assistance Services',
      },
    ],
  },
  {
    id: 'Arts_and_recreation_services',
    title: 'Arts and recreation services',
    children: [
      {
        id: 'Heritage_Activities',
        title: 'Heritage Activities',
      },
      {
        id: 'Creative_and_Performing_Arts_Activities',
        title: 'Creative and Performing Arts Activities',
      },
      {
        id: 'Sports_and_Recreation_Activities',
        title: 'Sports and Recreation Activities',
      },
      {
        id: 'Gambling_Activities',
        title: 'Gambling Activities',
      },
    ],
  },
  {
    id: 'Other_services',
    title: 'Other services',
    children: [
      {
        id: 'Repair_and_Maintenance',
        title: 'Repair and Maintenance',
      },
      {
        id: 'Personal_and_Other_Services',
        title: 'Personal and Other Services',
      },
      {
        id:
          'Private_Households_Employing_Staff_and_Undifferentiated_Goods-_and_Service-Producing_Activities_of_Households_for_Own_Use',
        title:
          'Private Households Employing Staff and Undifferentiated Goods and Service Producing Activities of Households for Own Use',
      },
    ],
  },
];
